import React from 'react';
import { bonuses } from '../../data/content';
import { SectionLabel } from '../ui/SectionLabel';
export function Bonuses() {
  return <section aria-labelledby="bonos-title" className="w-full bg-ink-850" data-id="element-17" data-mp="1hiptna4tfrqf">
      <div className="mx-auto max-w-5xl px-5 py-16 md:py-20" data-id="element-18" data-mp="1cm7q2dl81zfo">
        <div className="max-w-3xl" data-id="element-19" data-mp="18jkvw612w2fb">
          <SectionLabel data-id="element-20" data-mp="18km6yai3gox1">Incluidos hoy sin costo adicional</SectionLabel>
          <h2 id="bonos-title" className="mt-5 font-display text-3xl font-black leading-tight text-white md:text-4xl" data-id="element-21" data-mp="259lefnautmo6">
            Dos herramientas para aplicar el método desde el primer día
          </h2>
        </div>
        <p className="mt-8 rounded-xl bg-pitch px-6 py-5 text-center text-base font-bold text-white" data-id="element-22" data-mp="1w7c5v2z5c3df">
          Valor total de los bonos: <span className="text-subtle line-through" data-id="element-23" data-mp="ku09fd5pun1a">US$ 26</span>{' '}
          <span className="text-brand-green" data-id="element-24" data-mp="kvbctbv91srv">— hoy incluidos gratis</span>
        </p>
        <p className="mt-3 text-center text-xs text-subtle" data-id="element-25" data-mp="fu41j2twebgg">
          Precios expresados en dólares estadounidenses. Al finalizar tu compra, siempre pagarás en
          tu moneda local.
        </p>
        <div className="mt-6 grid gap-5 md:grid-cols-2" data-id="element-26" data-mp="1js80xdnhgcwz">
          {bonuses.map(bonus => <article key={bonus.number} className="flex h-full flex-col rounded-xl border border-ink-border bg-ink-card p-6 shadow-panel transition-colors duration-150 ease-out hover:border-brand-green" data-id="element-27" data-mp="15s70u0f1l9ik">
              <div className="flex flex-wrap items-center gap-3" data-id="element-28" data-mp="10tvs5t0hh51x">
                <span className="rounded-full bg-brand-gold/10 px-3 py-1 text-xs font-black uppercase tracking-[0.12em] text-brand-gold" data-id="element-29" data-mp="10v6t7l2jnypc">
                  {bonus.number}
                </span>
                <span className="text-xs font-semibold text-subtle line-through" data-id="element-30" data-mp="r4lvs0ylx080">
                  {bonus.originalPrice}
                </span>
                <span className="rounded-full bg-brand-greenDeep px-3 py-1 text-xs font-bold text-brand-greenSoft" data-id="element-31" data-mp="i34mp2jm9yst">
                  Gratis hoy
                </span>
              </div>
              <h3 className="mt-4 font-display text-xl font-bold text-white" data-id="element-32" data-mp="2f1v5v7ds8sld">{bonus.title}</h3>
              <p className="mt-3 text-[15px] leading-relaxed text-body" data-id="element-33" data-mp="2f00htk77skd2">{bonus.description}</p>
            </article>)}
        </div>
      </div>
    </section>;
}